export default "__VITE_ASSET__wNbYl3_n__"